module.exports = __webpack_public_path__ + "img/icon-house-active.a4402fd1.svg";